import React from 'react'
import PackagesPage from './PackagesPage'

function Corporates() {
  return (
    <div>
      <PackagesPage/>
    </div>
  )
}

export default Corporates